<template>
  <div>
    <Card title="On Boarding Banner">
      <template v-slot:body>
        <div class="flex flex-col pb-5 border-b">
          <h5 class="text-gray-700 text-sm mt-3 mb-6 font-bold uppercase text-left">
            Banner Form
          </h5>
          <form-item label='Image'>
            <template v-slot>
              <input
                type="file"
                class="block border border-grey-light w-full p-3 rounded mb-4"
                name="profile_picture"
                accept="image/*"
                @change="onFileChange"
              />
              <div class="tooltip" >
                <img
                  style="width: 150px;margin: 0px auto;"
                  v-if="input.file"
                  :src="input.file"
                  @click="changeImage"
                />
                <span class="hint-tooltip" ><font-awesome-icon :icon="['fas', 'times-circle']" size="2x" @click="changeImage" /></span>
                <p class="text-xs text-left" >Input 624 x 208 px image in JPG or PNG. Max image size 1MB</p>
              </div>
              <div class="flex flex-col pt-2">
                <text-error
                  v-if="$v.input.file.$dirty && !$v.input.file.required"
                  text="Please select banner image."
                >
                </text-error>
                <text-error
                  v-if="isFileLarge"
                  text="Please using image lower than 1MB."
                >
                </text-error>
                <text-error
                  v-if="isFileWrongFormat"
                  text="Please use a valid image format"
                >
                </text-error>
              </div>
            </template>
          </form-item>
          <div class="w-1/5">
            <Button variant="primary" class="w-full" @clicked="submit" label="Save">Save</Button>
          </div>
        </div>
        <div class="flex flex-col py-3">
          <h5 class="text-gray-700 text-sm mt-3 font-bold uppercase text-left">
            Banner List
          </h5>
          <div class="w-full p-3">
            <el-table :data="list" row-key="id" style="width: 100%">
              <el-table-column label="Image" key="cover" width="650">
                <template slot-scope="scope">
                  <div class="static inline-block text-center container-action">
                    <img :src="scope.row.url" style="width: 624px;height: 208px;object-fit: cover" />
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="Actions" align="right">
                <template slot-scope="scope">
                  <div class="static inline-block text-left container-action">
                    <VueCustomTooltip label="Delete" :position="'is-left'">
                      <button @click="deleteBanner(scope.row)" class="p-2 mr-2 rounded bg-red-500 hover:bg-red-600 focus:outline-none" >
                        <font-awesome-icon class="text-white" :icon="['fa', 'trash-alt']" />
                      </button>
                    </VueCustomTooltip>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </template>
    </Card>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import helpersMixin from '@/mixins/helpers.mixins';
import { mapActions } from 'vuex';
import axios from 'axios';
import Vue from 'vue';
import { Button, FormItem, Input, TextError } from '@/components/Layout/Form';
import Card from '@/components/Layout/Card.vue';

export default {
  name: 'OnboardingBanner',
  mixins: [validationMixin, helpersMixin],
  data() {
    return {
      isFileLarge: false,
      isFileWrongFormat: false,
      isError: false,
      input: {
        file: null,
      },
      list: [],
    };
  },
  validations() {
    return {
      input: {
        file: {
          required,
        },
      },
    };
  },
  async mounted() {
    await this.getData();
  },
  methods: {
    ...mapActions('AppSettingModule', [
      'requestCreateOnBoardingBanner', 'requestDeleteOnBoardingBanner', 'requestGetOnBoardingBanner',
    ]),
    async getData() {
      const data = await this.requestGetOnBoardingBanner();
      this.list = data;
    },
    resetState() {
      this.$v.$reset();
      this.isError = false;
      this.isFileLarge = false;
      this.isFileWrongFormat = false;
      this.input = Object.assign({}, { file: null });
    },
    async submit() {
      this.$v.$touch();
      if (!this.$v.$invalid && !this.isFileLarge && !this.isFileWrongFormat) {
        const cover = await axios({
          method: 'get',
          url: this.input.file,
          responseType: 'blob',
        }).then(this.processFileBlob);
        const data = {
          file: cover
        };
        await this.requestCreateOnBoardingBanner(data);
        this.resetState();
        await this.getData();
      }
    },
    processFileBlob(response) {
      const file = new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(response.data);
        reader.onloadend = () => {
          resolve(reader.result);
        };
      });
      return file.then(data => data);
    },
    onFileChange(e) {
      this.isFileLarge = false;
      this.isFileWrongFormat = false;
      const file = e.target.files[0];
      const image = new Image();
      image.onload = (ev) => {
        if ((image.width !== 624 && image.height !== 208)) {
          this.$v.dirty = true;
          this.isFileWrongFormat = true;
        }
      };
      if (file.size > 1024 * 1024) {
        this.$v.dirty = true;
        this.isFileLarge = true;
      }
      this.input.file = URL.createObjectURL(file);
      image.src = this.input.file;
    },
    changeImage() {
      this.input.file = null;
    },
    async deleteBanner(row) {
      Vue.swal({
        title: 'Delete Data!',
        text: 'Are you sure to delete banner?',
        icon: 'warning',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCancelButton: true,
      }).then(async (result) => {
        if (result.value) {
          await this.requestDeleteOnBoardingBanner({
            id: row.id,
          });
          await this.getData();
          this.$swal('Deleted', 'You successfully delete banner', 'success');
        }
      });
    },
  },
  components: {
    Button,
    Card,
    FormItem, Input, TextError
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/AppSetting/OnboardingBanner.vue